import { useMemo } from 'react'
import { useContractDetailsContext } from '../../../Providers/ContractDetailsContextProvider'
import { Attachment } from '../../../../../components/Attachment/Attachment'
import { fileNameFormatter } from '../../../../../helper/common'

export const VersionHistory = () => {
  const contractDetailsContext = useContractDetailsContext()

  const { loPHistoryDocuments } = contractDetailsContext.state

  const Documents = useMemo(
    () =>
      loPHistoryDocuments.map((document) => (
        <div
          key={`${document.file}${document.created_at}`}
          className="contract-version-history__document"
        >
          <div className="contract-version-history__node" />
          <Attachment.Row
            link={document.file}
            createdAt={document.created_at}
            filename={fileNameFormatter(document.file)}
            showDetails
            disableActions
          />
        </div>
      )),
    [loPHistoryDocuments]
  )

  return <div className="contract-version-history">{Documents}</div>
}
